export default function PreFallBanner() {
  return null;
}